var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.11465C8.34375 6.11465 8.63812 5.9948 8.88313 5.75511C9.12813 5.51541 9.25042 5.22762 9.25 4.89172C9.25 4.55541 9.1275 4.26741 8.8825 4.02772C8.6375 3.78803 8.34333 3.66838 8 3.66879C7.65625 3.66879 7.36188 3.78864 7.11687 4.02833C6.87188 4.26803 6.74958 4.55582 6.75 4.89172C6.75 5.22803 6.8725 5.51603 7.1175 5.75572C7.3625 5.99541 7.65667 6.11506 8 6.11465ZM8 12C7.91667 12 7.83333 11.9847 7.75 11.9541C7.66667 11.9236 7.59375 11.8828 7.53125 11.8318C6.01042 10.5172 4.875 9.29671 4.125 8.17039C3.375 7.04408 3 5.99195 3 5.01401C3 3.48535 3.50271 2.26752 4.50813 1.36051C5.51354 0.453503 6.6775 0 8 0C9.32292 0 10.4871 0.453503 11.4925 1.36051C12.4979 2.26752 13.0004 3.48535 13 5.01401C13 5.99236 12.625 7.04469 11.875 8.17101C11.125 9.29733 9.98958 10.5176 8.46875 11.8318C8.40625 11.8828 8.33333 11.9236 8.25 11.9541C8.16667 11.9847 8.08333 12 8 12Z",
    fill: "#D61D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.8c7d0067d5e9edef1fc00aa337f29e6e.svg";
export { ForwardRef as ReactComponent };